/* FL: Dealeasy wstrzykuje items[0][...] (wariant produktu glownego) do formularzy
   /cart/add produktow komplementarnych (related-product*) i wylacza natywny input "id",
   przez co submit dodawal produkt glowny. Ochrona trojwarstwowa:
   1) MutationObserver usuwa wstrzykniete inputy natychmiast po ich pojawieniu sie,
   2) czyszczenie + stopPropagation na click (capture) — delegowane handlery pluginu
      nie widza klikniecia, natywny submit i handler motywu na formie dzialaja dalej,
   3) czyszczenie na submit (capture) jako ostatnia linia. */
(function () {
  var SEL_FORM = 'form[id^="related-product"]';

  function sanitize(form) {
    if (!form) return;
    /* Hidden quantity to wstrzykniecie pluginu (motyw uzywa type="number" albo braku pola) —
       duplikat/disable pola powodowal, ze /cart/add dostawal zawsze quantity=1 */
    form.querySelectorAll('input[name^="items["], #lb-dealeasy-qs-attribute, input[type="hidden"][name="quantity"]').forEach(function (el) {
      el.remove();
    });
    ['id', 'product-id', 'section-id', 'quantity'].forEach(function (name) {
      var el = form.querySelector('input[name="' + name + '"]');
      if (el) el.disabled = false;
    });
  }

  function sanitizeAll() {
    document.querySelectorAll(SEL_FORM).forEach(sanitize);
  }

  var mo = new MutationObserver(sanitizeAll);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SEL_FORM + ' button[name="add"]') : null;
    if (!btn) return;
    sanitize(btn.form);
    e.stopPropagation();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches(SEL_FORM)) sanitize(form);
  }, true);

  if (document.readyState !== 'loading') sanitizeAll();
  else document.addEventListener('DOMContentLoaded', sanitizeAll);
})();
